import './StateBlock.css';

// #124 — Bloco de estado canônico (mesma estrutura centralizada pros 3 casos
// "mensagem": vazio / loading / erro). Skeletons (NCListSkeleton) e o
// LoadingSpinner continuam separados — são placeholders com forma de conteúdo.
const DEFAULT_ICON = { empty: 'inbox', loading: 'progress_activity', error: 'error' };

export default function StateBlock({ kind = 'empty', icon, title, message, action }) {
  const ic = icon || DEFAULT_ICON[kind] || 'info';
  const spin = kind === 'loading';
  return (
    <div className={`ui-state ui-state--${kind}`}>
      <span className={`material-symbols-outlined ui-state__icon${spin ? ' ui-state__icon--spin' : ''}`}>
        {ic}
      </span>
      {title && <h3 className="ui-state__title">{title}</h3>}
      {message && <p className="ui-state__message">{message}</p>}
      {action && <div className="ui-state__action">{action}</div>}
    </div>
  );
}
